import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/index.vue'

import MainCert from '../views/maincert.vue'
import TestCert from '../views/testcert.vue'
import DevCert from '../views/devcert.vue'


Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/main/transactions/:txId',
    name: 'MainCert',
    component: MainCert,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/test/transactions/:txId',
    name: 'TestCert',
    component: TestCert,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/dev/transactions/:txId',
    name: 'DevCert',
    component: DevCert,
    meta: {
      keepAlive: true
    }
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
